import { GrowthBook } from '@growthbook/growthbook';

const growthbook = new GrowthBook({
  apiHost: 'https://cdn.growthbook.io',
  clientKey: 'sdk-LNsgkds7DwILOCD',
  enableDevMode: true,
});
export default growthbook;
